export default "__VITE_ASSET__0f5a778f__"